import { Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { themeColors } from "../../utils/constants";
import { primaryAppPath } from "../../utils/appNavigation";

const Back = (props) => {
  const navigate = useNavigate()
  const {
    setMethod, value, to = primaryAppPath()
  } = props
  return (
  <Box className="about-back-container">
    <IconButton
      onClick={() => {
        if (setMethod) {
          setMethod(value)
        } else {
          navigate(to)
        }
      }}
      size="small" aria-haspopup="true"
    ><ArrowBackIcon sx={{ color: themeColors.primaryText }} />
    </IconButton>
  </Box>
  )
}
export default Back
